<template>
  <div :class="[showAsideMenu && 'management-layout', isNewPage && 'is-new-page']">
    <router-view v-if="!showAsideMenu"></router-view>
    <template v-else>
      <div class="management-menu-list">
        <template v-if="hasGroup">
          <el-menu
            class="menu-list"
            :default-active="activeGroupIndex"
            :unique-opened="true">
            <el-submenu
              v-for="(menu, key) in menuGroup"
              :key="key"
              :index="key"
            >
              <template slot="title">
                <span class="menu-label" :title="menu.label">{{ menu.label }}</span>
              </template>
              <el-menu-item
                v-for="(item, index) in menu.list"
                :key="index"
                :index="`${key}_${index}`"
                :hidden="item.hidden"
                @click="handleClick(item)"
              >
                <span class="menu-label" :title="item.label">{{ item.label }}</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </template>
        <template v-else>
          <el-menu class="menu-list" :default-active="`${activeMenuIndex}`">
            <el-menu-item
              v-for="(item, index) in menuList"
              :key="index"
              :index="`${index}`"
              @click="handleClick(item)"
            >
              <span class="menu-label" :title="getMenuLabel(item)">{{ getMenuLabel(item) }}</span>
            </el-menu-item>
          </el-menu>
        </template>
      </div>
      <div class="content">
        <router-view v-if="isNewPage"></router-view>
        <div v-else class="content-wrapper" :class="oldPageAdapterClass">
          <div class="content-center-wrapper">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import _ from 'lodash'
import { getIncludeRoutePath, mixedRouterPush } from '@/router/routes'

export default {
  components: {
  },
  data () {
    return {
      menuList: [],
      activeMenuIndex: -1,
      activeGroupIndex: '',
      hasGroup: false
    }
  },
  computed: {
    showAsideMenu () {
      if (this.$route.meta.hiddenAsideMenu) {
        return false
      }
      return true
    },
    menuGroup () {
      const menuList = this.menuList
      const menuGroup = {}
      _.forEach(menuList, (item, index) => {
        const menu = item.meta.menu
        const group = menu.group
        if (!group) {
          return false
        }
        if (!menuGroup[group.key]) {
          menuGroup[group.key] = {
            label: this.$t(group.labelKey),
            list: []
          }
        }
        menuGroup[group.key].list.push({
          label: menu.label,
          path: item.path,
          hidden: menu.hiddenInNewLayout,
          meta: item.meta
        })
      })
      return menuGroup
    },
    isNewPage () {
      let route = this.$route
      while (route) {
        if (route.meta?.isNewPage) {
          return true
        }
        route = route.meta?._parent
      }
      return false
    },
    oldPageAdapterClass () {
      if (this.isNewPage) {
        return ''
      }
      return this.$route.meta.oldPageAdapterClass
    }
  },
  created () {
    this.loadMenu()
  },
  destroyed () {
    this.$eventBus.$emit('hideElStyle', false)
  },
  methods: {
    getMenuLabel (menuRoute) {
      const meta = menuRoute.meta
      if (meta.menu) {
        const menu = meta.menu
        return menu.label || this.$t(menu.labelI18nKey)
      } else {
        return meta.title || this.$t(meta.titleI18nKey)
      }
    },
    loadMenu () {
      this.activeMenuIndex = -1
      const parent = this.$parent
      const layoutRoute = parent.menuList[parent.activeKey]
      const metaInfoList = [this.$route.meta]
      let metaInfo = metaInfoList[0]
      while ((metaInfo = metaInfo._parent?.meta)) {
        metaInfoList.push(metaInfo)
      }
      if (layoutRoute && layoutRoute.route && layoutRoute.route.children) {
        let menuIndex = 0
        this.hasGroup = layoutRoute.route.meta?.hasGroup
        this.menuList = _.filter(layoutRoute.route.children, (item) => {
          const hasPermission = this.hasAnyPermission(item.meta.permission)
          if (metaInfoList.includes(item.meta)) {
            if (hasPermission) {
              this.activeMenuIndex = menuIndex
            } else {
              this.$router.replace('/error/no-permission')
              return false
            }
          }
          if (!this.hasGroup && item.meta?.menu?.hiddenInNewLayout) {
            return false
          }
          if (hasPermission) {
            menuIndex++
          }
          return hasPermission
        })
        this.initMenuGroupKey()
      }
      this.$eventBus.$emit('hideElStyle', !this.isNewPage)
    },
    initMenuGroupKey () {
      const menuList = this.menuList
      const menuGroup = {}
      _.forEach(menuList, (item, index) => {
        const menu = item.meta.menu
        const group = menu.group
        if (!group) {
          return false
        }
        if (_.isNil(menuGroup[group.key])) {
          menuGroup[group.key] = 0
        } else {
          menuGroup[group.key] += 1
        }
        if (this.activeMenuIndex === index) {
          this.activeGroupIndex = `${group.key}_${menuGroup[group.key]}`
        }
      })
      if (this.activeMenuIndex < 0) {
        const defaultPath = this.menuList[0].path
        if (this.$route.path === defaultPath) {
          return
        }
        const includePath = getIncludeRoutePath(defaultPath)
        if (includePath) {
          this.$router.replace(includePath)
          this.activeMenuIndex = 0
        } else {
          window.location.href = defaultPath
        }
      }
    },
    handleClick (route) {
      const path = route.path
      if (this.$route.path === path) {
        this.reloadPage()
      } else {
        let isAllInclude = false
        let meta = route.meta
        while (meta) {
          if (meta.isAllInclude) {
            isAllInclude = true
            break
          }
          meta = meta._parent?.meta
        }
        if (isAllInclude) {
          this.$router.push(path)
        } else if (route.meta.isInclude) {
          mixedRouterPush(path)
        } else {
          location.href = path
        }
      }
    }
  },
  watch: {
    $route () {
      this.loadMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.management-layout {
  padding-left: 0;
  margin-left: -24px;
  min-height: 100%;
  display: flex;

  &.is-new-page {
    .content {
      min-height: 100%;
    }
  }

  &:not(.is-new-page) {
    .content {
      overflow: hidden;
    }
  }

  .management-menu-list {
    flex-grow: 0;
    width: 280px;
    margin: -18px 0;
    background: #FFFFFF;
    box-shadow: 3px -1px 6px -3px rgba(0,0,0,0.12);

    .menu-list {
      border: 0;
      width: 280px;
    }

    .menu-label {
      width: 100%;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .content {
    flex-grow: 1;
    margin-left: 18px;
    min-width: 1024px;

    .content-wrapper {
      min-height: 100%;
      padding: 20px;
      background: #FFFFFF;

      &.job-referral-page {
        .content-center-wrapper {
          width: auto;
        }
      }

      .content-center-wrapper {
        width: 720px;
        padding-top: 30px;
        padding-left: 25px;
        padding-right: 20px;
        margin: 0 auto;
        overflow-x: hidden;
        overflow-y: initial;
      }
    }
  }
}
.flex-layout {
  .management-layout {
    margin-left: 0;
    justify-content: center;
  }
}
</style>
